module.exports = __webpack_public_path__ + "promo/app-store-badges/apple-app-store-ja-d92f75e4e94a54f1ade709477baae34a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/apple-app-store-ja.svg
// module id = Lgv1
// module chunks = 23